export const checkIfTokenHasExpired = (errorCode) => {
    if (errorCode && errorCode === 401) {
        return true;
    }
    return false;
}